export default __webpack_public_path__ + "static/media/leave-left.b3efe980.png";